/*
  Flowkeeper - Pomodoro timer for power users and teams
  Copyright (c) 2023 Constantine Kulak, Geoffrey Espagne

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation; either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/

import {AbstractDataContainer} from "./abstract_data_container";
import {Root} from "./root";
import {Workitem} from "./workitem";
import {Origin} from "./abstract_stragegy";
import {Connection} from "./connection";

export class Backlog extends AbstractDataContainer<Root, Workitem> {
    public name: string|undefined;

    public constructor(another?: Backlog, id?: string, parent?: Root, createDate?: Date, name?: string) {
        if (another) {
            super(another);
            this.name = another.name;
        } else {
            super(undefined, id, parent, createDate);
            this.name = name;
        }
    }
    
    public clone(): Backlog {
        return new Backlog(this);
    }
}


// Strategies

export function CreateBacklog(origin: Origin, data: Root, connection: Connection, seq: number, when: Date, who: string, ...params: string[]): void {
    const id = params[0];
    const name = params[1];
    if (data.children.get(id)) {
        throw new Error(`Attempt to create a duplicate backlog ${id}`);
    }
    data.children.set(id, new Backlog(undefined, id, data, when, name));
}
CreateBacklog.realName = 'CreateBacklog'    // Avoid the compiler mangling the function names

export function DeleteBacklog(origin: Origin, data: Root, connection: Connection, seq: number, when: Date, who: string, ...params: string[]): void {
    const id = params[0];
    if (!data.children.get(id)) {
        throw new Error(`Attempt to delete a backlog ${id} that doesn't exist`);
    }
    data.children.delete(id);
}
DeleteBacklog.realName = 'DeleteBacklog'

export function RenameBacklog(origin: Origin, data: Root, connection: Connection, seq: number, when: Date, who: string, ...params: string[]): void {
    const id = params[0];
    const name = params[1];
    const backlog = data.children.get(id);
    if (!backlog) {
        throw new Error(`Attempt to rename a backlog ${id} that doesn't exist`);
    }
    backlog.name = name;
}
RenameBacklog.realName = 'RenameBacklog'
